
<div class="flex flex-row w-full">
  <div class="flex-grow">
    {{ text.name }}<br />

    <textarea v-model="enteredText" :class="smallscreen ? 'text-xs' : ''" :rows="rows"
      class="mt-1 focus:ring-gray-400 focus:border-gray-400 block w-full sm:text-sm border-gray-300 rounded-md"></textarea>

    <div v-if="hasTextColors" class="mt-2">
      <div v-for="(color, idx) in textColors" :key="idx" :style="`background-color: rgba(${color},1)`"
        @click="changeTextColor(color)"
        class="w-2 h-2 rounded float-left border-2  hover:border-brandhelfer-green cursor-pointer"
        :class="[
          smallscreen ? 'p-3 mr-1 mb-1' : 'p-4 mr-2 mb-2',
          selectedColor == color
            ? 'border-brandhelfer-green cursor-default'
            : 'border-gray-200'
        ]"></div>
    </div>
  </div>
  <div class="w-1/5">
    <toggle :idx="text.id" :enabled="text.enabled" @toggled="statusToggled"></toggle>
  </div>

  <horizontal-divider />
</div>
